import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.p5w_1 = delegate;
        this.q5w_1 = call;
      }
      *a5f(frame, $completion) {
        yield* this.p5w_1.a5f(frame, $completion);
        return Unit_instance;
      }
      *l4n($completion) {
        yield* this.p5w_1.l4n($completion);
        return Unit_instance;
      }
      w5e(_set____db54di) {
        this.p5w_1.w5e(_set____db54di);
      }
      x5e() {
        return this.p5w_1.x5e();
      }
      y5e() {
        return this.p5w_1.y5e();
      }
      z5e() {
        return this.p5w_1.z5e();
      }
      ww() {
        return this.p5w_1.ww();
      }
      v5e(negotiatedExtensions) {
        this.p5w_1.v5e(negotiatedExtensions);
      }
      u5e() {
        return this.p5w_1.u5e();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.r5w_1 = session;
        this.s5w_1 = call;
      }
      *a5f(frame, $completion) {
        yield* this.r5w_1.a5f(frame, $completion);
        return Unit_instance;
      }
      *l4n($completion) {
        yield* this.r5w_1.l4n($completion);
        return Unit_instance;
      }
      w5e(_set____db54di) {
        this.r5w_1.w5e(_set____db54di);
      }
      x5e() {
        return this.r5w_1.x5e();
      }
      y5e() {
        return this.r5w_1.y5e();
      }
      z5e() {
        return this.r5w_1.z5e();
      }
      ww() {
        return this.r5w_1.ww();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
